/**
 * 인증 API 서비스
 */

import { api } from '../utils/api';
import {
  LoginRequest,
  SignupRequest,
  AuthResponse,
  PasswordResetRequest,
} from '../types/auth';
import { User } from '../types/user';

/**
 * 로그인 API
 * - FastAPI OAuth2PasswordRequestForm 사용
 * - username 필드에 이메일 전송
 */
export const login = async (credentials: LoginRequest): Promise<AuthResponse> => {
  // OAuth2 Form 데이터 생성
  const formData = new FormData();
  formData.append('username', credentials.email); // OAuth2 form은 username 필드 사용
  formData.append('password', credentials.password);

  const response = await api.post<AuthResponse>('/auth/login', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  return response.data;
};

/**
 * 회원가입 API (그룹 관리자용)
 */
export const signup = async (data: SignupRequest): Promise<{ message: string }> => {
  const response = await api.post('/auth/signup', data);
  return response.data;
};

/**
 * 현재 사용자 정보 조회
 */
export const getCurrentUser = async (): Promise<User> => {
  const response = await api.get<User>('/auth/me');
  return response.data;
};

/**
 * 로그아웃
 * - 클라이언트 사이드에서 토큰 삭제로 처리
 * - 서버 사이드 로그아웃 API가 있다면 호출
 */
export const logout = async (): Promise<void> => {
  try {
    // 백엔드에 로그아웃 API가 있다면 호출
    // await api.post('/auth/logout');
  } catch (error) {
    console.error('Logout API error:', error);
  }
};

/**
 * 비밀번호 재설정 요청
 * - 이메일로 재설정 링크 발송
 */
export const requestPasswordReset = async (
  data: PasswordResetRequest
): Promise<{ message: string }> => {
  const response = await api.post('/auth/request-password-reset', data);
  return response.data;
};

/**
 * 비밀번호 변경
 */
export const resetPassword = async (
  token: string,
  newPassword: string
): Promise<{ message: string }> => {
  const response = await api.post('/auth/reset-password', {
    token,
    new_password: newPassword,
  });
  return response.data;
};

/**
 * 토큰 갱신 (Refresh Token 사용)
 */
export const refreshAccessToken = async (
  refreshToken: string
): Promise<AuthResponse> => {
  const response = await api.post<AuthResponse>('/auth/refresh', {
    refresh_token: refreshToken,
  });
  return response.data;
};

const authService = {
  login,
  signup,
  getCurrentUser,
  logout,
  requestPasswordReset,
  resetPassword,
  refreshAccessToken,
};

export default authService;
